import { PencilRuler, UserRound } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import schema from "./schema";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { useUpdateProfileMutation } from "@/redux/features/api/profile/profileApiSlice";
import UserInput from "./UserInput";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useCreateFreeConsultationMutation } from "@/redux/features/api/Consultation/consultationApiSlice";
import { useRouter } from "next/navigation";
import { useTranslate } from "@/components/base/providers/TranslateProv";
import { toast } from "react-toastify";
import { getErrorMessage } from "@/utils/error/getErrorMessage";
// import { displayToast } from "@/redux/app/api/toastApi";

type Props = {
  data: any;
};

function FreeConsultationForm({ data }: Props) {
  const router = useRouter();
  const [selectedMethod, setSelectedMethod] = useState("0");
  const [phone, setPhone] = useState<any>("");
  const [whatsappNumber, setWhatsappNumber] = useState<any>("");
  const [message, setMessage] = useState<any>("");
  // console.log(data);
  const [updateProfile, { isLoading }] = useUpdateProfileMutation();
  const [CreateFreeConsultation, { isSuccess, error }] =
    useCreateFreeConsultationMutation();
  const prepareDefaultValues = (data: any) => {
    if (!data) return {};

    return {
      percentage: data.percentage || "",
      communicate_at: data.communicate_at || "",
      year_obtained: data.year_obtained || "",
      country_obtained: data.country_obtained || "",
      year_obtaining_certificate: data?.year_obtaining_certificate || "0",
      country_obtaining_certificate: data?.country_obtaining_certificate || "0",
    };
  };
  const form = useForm<Yup.InferType<typeof schema>>({
    resolver: yupResolver(schema),
    defaultValues: prepareDefaultValues(data),
  });

  const {
    getValues,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = form;

  useEffect(() => {
    if (data) {
      reset(prepareDefaultValues(data));
    }
    if (data?.phone_number) {
      setPhone(data?.phone_number);
    }
    if (data?.whatsapp) {
      setWhatsappNumber(data?.whatsapp);
    }
    if (data?.communicate_at) {
      setSelectedMethod(`${data?.communicate_at}`);
    }
  }, [data, reset]);
  const onSubmit = async (data: Yup.InferType<typeof schema>) => {
    const communicate =
      selectedMethod == "0"
        ? "whatsapp"
        : selectedMethod == "1"
        ? "email"
        : "phone";
    const consultationData = {
      communicate: communicate,
      message: message,
    };
    
    if (!phone && communicate === "phone") {
      return toast.error(locale === "ar" ? "رقم الهاتف مطلوب" : "Phone number is required");
    }
    if (!whatsappNumber && communicate === "whatsapp") {
      return toast.error(locale === "ar" ? "رقم الواتساب مطلوب" : "WhatsApp number is required");
    }
    const updateUserData = {
      communicate_at: selectedMethod,
      phone_number: phone,
      whatsapp: whatsappNumber,
      percentage: data?.percentage || "0",
      year_obtaining_certificate: data?.year_obtaining_certificate || "0",
      country_obtaining_certificate: data?.country_obtaining_certificate || "0",
    };

    try {
      await updateProfile(updateUserData).unwrap();
      await CreateFreeConsultation(consultationData).unwrap();
      router.push(`/services`);
    } catch (error: any) {
      console.error("Form error:", error);
      const errorMessage = getErrorMessage(error, locale);
      toast.error(errorMessage);
    }
  };

  const { locale } = useTranslate();
  useEffect(() => {
    if (isSuccess) {
      toast.success("تمت عملية الحجز بنجاح");
    }
  }, [isSuccess]);
  return (
    <div className=" bg-white shadow-sm border  lg:p-[30px] rounded-[16px]">
      <div className=" flex items-center  flex-col justify-center">
        {/* user info card */}
        <div className="w-full">
          <form
            onSubmit={handleSubmit((values) => onSubmit(values))}
            className="p-2"
          >
            <UserInput
              control={control}
              errors={errors}
              selectedMethod={selectedMethod}
              setSelectedMethod={setSelectedMethod}
              whatsappNumber={whatsappNumber}
              setWhatsappNumber={setWhatsappNumber}
              phone={phone}
              setPhone={setPhone}
              message={message}
              setMessage={setMessage}
            />
            <div className="mt-4 flex justify-between items-center p-4">
              <div className="w-full">
                <Button disabled={isLoading} className="grow text-lg w-full">
                  {locale === "ar"
                    ? "استشاره سفير الجامعات"
                    : "University Ambassador Consultation"}
                </Button>
              </div>
              <div className="w-fit relative">
                <Button className="w-fit bg-[#F8F9FA] mr-2 font-semibold text-primaryColor">
                  {locale === "ar" ? "مجانا" : "Free"}
                </Button>
                <Badge className="absolute -top-4 -left-[8px] bg-destructive rounded-full">
                  100%
                </Badge>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default FreeConsultationForm;
